<script setup>
import { ref } from 'vue';
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

defineProps({
    data: { type: Object, default: () => {} },
    coverColor: {
        type: String,
        default: '',
    },
});

const videoref = ref(null);
const isPlaying = ref(false);
const click = () => {
    const player = new Plyr(videoref.value, {
        autopause: true,
        autoplay: true,
    });
    isPlaying.value = true;
    player.play();
};
</script>

<template>
    <div class="VideoCover relative h-full w-full overflow-hidden rounded-xl">
        <div class="VideoCover__video absolute left-0 top-0 h-full w-full transition duration-1000">
            <div
                ref="videoref"
                data-plyr-provider="youtube"
                :data-plyr-embed-id="data.videoUrl"
            />
        </div>
        <transition
            enter-active-class="transition-opacity duration-1000"
            leave-active-class="transition-opacity duration-1000"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
            mode="out-in"
        >
            <div
                v-if="!isPlaying"
                class="VideoCover__cover absolute left-0 top-0 h-full w-full"
            >
                <Cover
                    :color="coverColor"
                    :data="data.cover"
                    class="relative h-full w-full"
                />
                <div
                    class="VideoCover__btn h-25 w-25 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 cursor-pointer text-white md:h-52 md:w-52"
                    v-on:click="click"
                >
                    <svg
                        v-if="landscape || tablet"
                        class="fill-current"
                        viewBox="0 0 210 210"
                    >
                        <path d="M105,210A105,105,0,1,1,210,105,105.12,105.12,0,0,1,105,210ZM105,2A103,103,0,1,0,208,105,103.12,103.12,0,0,0,105,2Z" />
                        <path
                            d="M96.23,105a24.11,24.11,0,0,1-3.09,11.82,2.72,2.72,0,0,0,.44,3.27c1,1,2.38.71,3.68,0,1-.62,16.57-9.62,23.08-13.4a1.9,1.9,0,0,0,0-3.28c-6.51-3.78-22-12.78-23.08-13.4-1.3-.76-2.65-1-3.68,0a2.72,2.72,0,0,0-.44,3.27A24.11,24.11,0,0,1,96.23,105Z"
                        />
                    </svg>
                    <svg
                        v-if="portrait"
                        class="fill-current"
                        viewBox="0 0 50 50"
                    >
                        <path
                            d="M21.22,24.74A12.59,12.59,0,0,1,19.59,31a1.42,1.42,0,0,0,.24,1.72,1.55,1.55,0,0,0,1.93,0l12.13-7a1,1,0,0,0,0-1.73c-3.42-2-11.58-6.71-12.13-7a1.53,1.53,0,0,0-1.93,0,1.41,1.41,0,0,0-.24,1.71A12.6,12.6,0,0,1,21.22,24.74Z"
                        />
                        <path d="M25,50A25,25,0,1,1,50,25,25,25,0,0,1,25,50ZM25,2A23,23,0,1,0,48,25,23,23,0,0,0,25,2Z" />
                    </svg>
                </div>
            </div>
        </transition>
    </div>
</template>
